import { render } from "./StoreStatusHistoryView.vue?vue&type=template&id=0d130c84&scoped=true"
import script from "./StoreStatusHistoryView.vue?vue&type=script&lang=js"
export * from "./StoreStatusHistoryView.vue?vue&type=script&lang=js"

import "./StoreStatusHistoryView.vue?vue&type=style&index=0&id=0d130c84&scoped=true&lang=css"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d130c84"]])

export default __exports__